import { EndpointGuard } from '../../helpers/auth';
import {
  dashboardCollectionGuard,
  dashboardResourceGuard,
} from './_api/dashboard';

export const dashboardCollection = dashboardCollectionGuard;
export const dashboardResource = dashboardResourceGuard;

export const routeGuard: EndpointGuard = {
  oneOf: [dashboardCollection, dashboardResource],
};
